import React from 'react';
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

const useTableTask = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isCompletedFilter = searchParams.get("is-completed");

    const tasks = useSelector(state => state.tasks);
    const tables = useSelector(state => state.tables);
    const parcels = useSelector(state => state.parcels); // Lekérjük a parcellákat
    const user = useSelector(state => state.user);
    // const [searchKey, setSearchKey] = useState("");

    const convertStringArrayToIntegerArray = (strArr) => strArr.map(Number);

    const table = params.tableId ? tables.find(element => element.table_id === Number(params.tableId)) : null;
    // const tasksByTable = table
    //     ? tasks.filter(element => convertStringArrayToIntegerArray(element.table_id).includes(Number(params.tableId)))
    //     : [];

    const relatedParcels = (table) => {
        const relatedParcels = parcels.filter(parcel => parcel.table_id === table.table_id)
        return relatedParcels ? relatedParcels : '-';
    };

    const tableName = (id) => {
        const table = tables.find(table => Number(table.table_id) === Number(id));
        return table ? table.name : '';
    };

    const redirectToTable = (e, url) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(url);
    };

    const isNebihSendable = (task) => {
        if (task.is_nebih_sendable) {
            return <FontAwesomeIcon
                key={'is_nebih_sendable'}
                title={'Beküldésre vár'}
                className="icon"
                style={{ float: 'right' }}
                icon={'fa fa-solid fa-cloud-arrow-up'}
            />;
        }
        return null;
    };

    const statusIcons = (task) => {
        if (task.eGN_status && task.eGN_status.icons) {
            return task.eGN_status.icons.map((icon, index) => (
                <FontAwesomeIcon
                    key={index}
                    title={icon.tooltip}
                    className="icon"
                    style={{ float: 'right' }}
                    icon={icon.icon_class}
                />
            ));
        }
        return null;
    };

    const isCompleted = (task) => {
        if (task.completed_at) {
            return <FontAwesomeIcon
                key={'completed_at'}
                title={'Véglegesített'}
                className="icon"
                style={{ float: 'right' }}
                icon={faCircleCheck}
            />;
        }
        return null;
    };

    const [taskStates, setTaskStates] = useState(
        JSON.parse(localStorage.getItem('taskStates')) || {}
    );
    
    const toggleTaskState = (taskId) => {
        setTaskStates(prevStates => {
            const newStates = { ...prevStates, [taskId]: !prevStates[taskId] };
            localStorage.setItem('taskStates', JSON.stringify(newStates));
            return newStates;
        });
    };
    
    const allTasksOpen = Object.values(taskStates).every(state => state);
    const toggleAllTasks = () => {
        const newState = !allTasksOpen;
        const updatedStates = Object.fromEntries(tasks.map(task => [task.id, newState]));
        setTaskStates(updatedStates);
        localStorage.setItem('taskStates', JSON.stringify(updatedStates));
    };

    const matchesCompletionFilter = (task) => {
        if (isCompletedFilter === "true") return !!task.completed_at;
        if (isCompletedFilter === "false") return !task.completed_at;
        return true;  // nincs filter, mindent visszaad
    };
    
    // const filteredTasks = tasks
    //     .filter(task => task.name.toLowerCase().includes(searchKey.toLowerCase()))
    //     .filter(matchesCompletionFilter)
    //     .map(task => ({
    //         ...task,
    //         editable: task.sub_tasks.some(subtask => subtask.user_id && subtask.user_id === user.id),
    //         user_id: user.id 
    //     }));

    const tasksByTable = table
        ? tasks
            .filter(element => convertStringArrayToIntegerArray(element.table_id).includes(Number(params.tableId)))
            .filter(matchesCompletionFilter)
            .map(task => ({
                ...task,
                editable: task.sub_tasks.some(subtask => subtask.user_id && subtask.user_id === user.id)
            }))
        : [];

    if (table) {
        table.id = table.table_id;
    }

    return {
        table,
        tasksByTable,
        relatedParcels,
        // searchKey,
        // setSearchKey,
        redirectToTable,
        tableName,
        // filteredTasks,
        navigate,
        isNebihSendable,
        statusIcons,
        isCompleted,
        taskStates,
        toggleTaskState,
        toggleAllTasks,
        allTasksOpen
    };
};

export default useTableTask;
